import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="definitionable-select"
// This controller manages the two-step selection of a definitionable (Program or AssessmentDefinition)
// for an Enroller form.
export default class extends Controller {
  static targets = [
    "typeSelect",
    "programSelect",
    "assessmentDefinitionSelect",
    "titleInput",
    "descriptionInput",
  ]
  static values = {
    infoUrl: {
      type: String,
      default: "/admin/enrollers/definitionable_info",
    },
  }

  connect() {
    this.updateVisibility()
    this.setupDefinitionableChangeListeners()
  }

  setupDefinitionableChangeListeners() {
    const programSelect = this.programSelectTarget.querySelector("select")
    const assessmentDefinitionSelect =
      this.assessmentDefinitionSelectTarget.querySelector("select")

    if (programSelect) {
      programSelect.addEventListener("change", () =>
        this.definitionableChanged("Program", programSelect.value),
      )
    }
    if (assessmentDefinitionSelect) {
      assessmentDefinitionSelect.addEventListener("change", () =>
        this.definitionableChanged(
          "AssessmentDefinition",
          assessmentDefinitionSelect.value,
        ),
      )
    }
  }

  typeChanged() {
    this.clearSelections()
    this.updateVisibility()
  }

  async definitionableChanged(type, id) {
    if (!id) return

    try {
      const response = await get(this.infoUrlValue, {
        query: { type, id },
        responseKind: "json",
      })

      if (response.ok) {
        const data = await response.json
        this.prefillFields(data)
      }
    } catch (error) {
      console.error("Failed to fetch definitionable info:", error)
    }
  }

  prefillFields(data) {
    if (this.hasTitleInputTarget) {
      this.titleInputTarget.value = data.title || ""
    }
    if (this.hasDescriptionInputTarget) {
      const editor = this.descriptionInputTarget.querySelector("trix-editor")
      if (editor && editor.editor) {
        editor.editor.loadHTML(data.description || "")
      }
    }
  }

  updateVisibility() {
    const selectedType = this.typeValue()
    const programSelect = this.programSelectTarget.querySelector("select")
    const assessmentDefinitionSelect =
      this.assessmentDefinitionSelectTarget.querySelector("select")

    if (selectedType === "Program") {
      this.enableSelect(programSelect)
      this.disableSelect(assessmentDefinitionSelect)
    } else if (selectedType === "AssessmentDefinition") {
      this.disableSelect(programSelect)
      this.enableSelect(assessmentDefinitionSelect)
    } else {
      this.disableSelect(programSelect)
      this.disableSelect(assessmentDefinitionSelect)
    }
  }

  enableSelect(select) {
    if (!select) return
    select.disabled = false
    if (select.tomselect) {
      select.tomselect.enable()
    }
  }

  disableSelect(select) {
    if (!select) return
    select.disabled = true
    if (select.tomselect) {
      select.tomselect.disable()
    }
  }

  clearSelections() {
    // Clear the TomSelect instances when switching types
    const programSelect = this.programSelectTarget.querySelector("select")
    const assessmentDefinitionSelect =
      this.assessmentDefinitionSelectTarget.querySelector("select")

    if (programSelect && programSelect.tomselect) {
      programSelect.tomselect.clear()
    }
    if (assessmentDefinitionSelect && assessmentDefinitionSelect.tomselect) {
      assessmentDefinitionSelect.tomselect.clear()
    }
  }

  typeValue() {
    if (this.hasTypeSelectTarget) {
      return this.typeSelectTarget.value
    } else {
      return "AssessmentDefinition"
    }
  }
}
